module.exports = "assets/img/hero-bottom-img.jpg";